import { render, staticRenderFns } from "./ladder-info.vue?vue&type=template&id=05bc23a5&scoped=true"
import script from "./ladder-info.vue?vue&type=script&lang=js"
export * from "./ladder-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bc23a5",
  null
  
)

export default component.exports